import { resolveMerchStoreApiUrl } from './merchstore';

const GET_MEMBER_CART_SUMMARY = resolveMerchStoreApiUrl(
  '/.netlify/functions/merchstore-api/fetchMemberCartSummary'
);

const APPLY_MEMBER_VOUCHERS = resolveMerchStoreApiUrl(
  '/.netlify/functions/merchstore-api/applyMemberVouchers'
);

export { GET_MEMBER_CART_SUMMARY, APPLY_MEMBER_VOUCHERS };
